import * as React from "react";
import Layout from "../../components/layout";
import Seo from "../../components/seo";
import EcoAlliance from '../../components/Eco-Alliance/EcoAlliance/EcoAlliance';

const EcoAllianceIndex = () => (
  <Layout>
    <Seo title="Home" />
    <div className="noissue-eco-alliance">
      <EcoAlliance />
    </div>
  </Layout>
)

export default EcoAllianceIndex;
